import React, { useState } from "react";
import { Switch, Route } from "react-router-dom";
import VentureSidebar from "./VentureSidebar";

import Dashboard from "./Pages/Dashboard";
import Conversations from "./Pages/Conversations";
// import FeedbackForm from "./Pages/FeedbackForm";
import FeedbackPage from "./Pages/FeedbackPage";
import ChatSelection from "./Pages/ChatSelection";

import "./venture.css";

const VentureLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="venture-layout">

      <VentureSidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />

      <div className="venture-content">

        <div className="venture-mobile-header">
          <button
            className="venture-menu-btn"
            onClick={() => setSidebarOpen(true)}
          >
            ☰
          </button>

          <h4>Venture Portal</h4>
        </div>

        <Switch>

          <Route
            exact
            path="/venture"
            component={Dashboard}
          />

          <Route
            exact
            path="/venture/conversations"
            component={Conversations}
          />

          <Route
            exact
            path="/venture/chat-selection"
            component={ChatSelection}
          />

          <Route
            exact
            path="/venture/feedback"
            component={FeedbackPage}
          />

          <Route
            component={Dashboard}
          />

        </Switch>

      </div>

    </div>
  );
};

export default VentureLayout;